const path = require("path");

module.exports = {
  i18n: {
    defaultLocale: process.env.NEXT_PUBLIC_DEFAULT_LOCALE || "et",
    locales: (process.env.NEXT_PUBLIC_SUPPORTED_LOCALES || "en,et").split(","),
    localeDetection: false,
  },
  localePath: path.resolve("./public/locales"),
  reloadOnPrerender: process.env.NODE_ENV === "development",
  // react: {
  //   useSuspense: true,
  //   wait: true,
  // },
  // interpolation: {
  //   escapeValue: false,
  //   formatSeparator: ',',
  //   prefix: '{{',
  //   suffix: '}}',
  // },
  fallbackLng: "en",
  // debug: false,
  // backend: {
  //   loadPath: '/locales/{{lng}}/{{ns}}.json',
  //   addPath: '/locales/{{lng}}/{{ns}}.missing.json',
  //   allowMultiLoading: false,
  //   crossDomain: false,
  //   withCredentials: false,
  //   overrideMimeType: true,
  //   // parse: (data) => JSON.parse(data),
  // },
  // detection: {
  //   order: ['cookie', 'querystring', 'localStorage', 'sessionStorage', 'path', 'subdomain'],
  //   caches: ['cookie'],
  //   cookieMinutes: 10,
  //   cookieDomain: process.env.NEXT_PUBLIC_DOMAIN,
  //   cookieOptions: { path: '/', sameSite: 'strict' },
  // },
  // saveMissing: true,
  // saveMissingTo: 'fallback',
  // localePath: typeof window === 'undefined' ? 'public/locales' : 'locales',
  // localePath: typeof window === 'undefined' ? require('path').resolve('./public/locales') : '/locales123',
  // ns: ['common'],
  defaultNS: "common",
  // serverSideTranslations: true,
  cache: {
    enabled: true,
    prefix: "next-i18next",
  },
};
